<template>
    <v-dialog v-model="showDialog" max-width="500">
        <v-card>
            <v-card-title>
                <span class="headline">
                    {{
                        isNew
                            ? 'Create Permission'
                            : 'Edit Permission: ' + permission?.name
                    }}
                </span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field
                                v-model="form.name"
                                label="Name"
                                required
                                counter="255"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                v-model="form.description"
                                label="Description"
                                required
                                counter="255"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="info" text @click="close">
                    <v-icon left>mdi-close</v-icon>
                    Close
                </v-btn>
                <v-btn :loading="loading" color="success" text @click="save">
                    <v-icon left>mdi-content-save</v-icon>
                    Save
                </v-btn>
                <v-btn v-if="!isNew" color="red" text @click="deletePermission">
                    <v-icon left>mdi-delete</v-icon>
                    Delete
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from 'axios';
export default {
    name: 'PermissionDialog',
    props: {
        value: Boolean,
        permission: Object,
        isNew: Boolean
    },
    data() {
        return {
            loading: false,
            form: {
                name: '',
                description: ''
            }
        };
    },
    computed: {
        showDialog: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        }
    },
    watch: {
        showDialog(newVal) {
            if (newVal) {
                this.resetForm();
            }
        }
    },
    methods: {
        async save() {
            this.loading = true;
            let url = '/v2/system/permissions';
            try {
                if (this.isNew) {
                    await axios
                        .post(url, this.form)
                        .then(response => {
                            this.$emit('create', response.data);
                            this.$store.dispatch('setSnackbar', {
                                text: 'Permission created',
                                color: 'success',
                                timeout: 3000
                            });
                        })
                        .catch(error => {
                            console.error(error);
                        });
                } else {
                    await axios
                        .put(url + '/' + this.permission.id, this.form)
                        .then(response => {
                            this.$emit('update', response.data);
                            this.$store.dispatch('setSnackbar', {
                                text: 'Permission updated',
                                color: 'success',
                                timeout: 3000
                            });
                        })
                        .catch(error => {
                            console.error(error);
                        });
                }
            } catch (error) {
                console.error(error);
            } finally {
                this.loading = false;
                this.showDialog = false;
            }
        },
        async deletePermission() {
            this.loading = true;
            await axios
                .delete(`/v2/system/permissions/${this.permission.id}`)
                .then(() => {
                    this.$emit('delete', this.permission);
                })
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        close() {
            this.showDialog = false;
        },
        resetForm() {
            if (this.isNew) {
                this.form = {
                    name: '',
                    description: ''
                };
            } else {
                this.form = {
                    name: this.permission.name,
                    description: this.permission.description
                };
            }
        }
    }
};
</script>
